import { combineReducers } from '@reduxjs/toolkit';
import authReducer from './modules/auth/authSlice';
import branchReducer from './modules/branch/slice';
import patientRegistrationReducer from './modules/admin/patientRegistartion/slice';
import patientInformationReducer from './modules/admin/patientInformation/slice';
import patientEmergencyContactReducer from './modules/admin/patientEmergencyContactInfo/slice';
import patientInsuranceReducer from './modules/admin/patientInsurance/slice';
import patientPhysicianReducer from './modules/admin/patientPhysician/slice';
import patientMedicalHistoryReducer from './modules/admin/patientMedicalHistory/slice';
import patientLifeStyleReducer from './modules/admin/patientLifeStyle/slice';
import patientAcknowledgementReducer from './modules/admin/patientAcknowledgement/slice';
import patientConsentReducer from './modules/admin/patientConsent/slice';
import patientProfileReducer from './modules/admin/patientProfile/slice';
import profileReducer from './modules/profile/slice';
import staffReducer from './modules/staff/slice';
import mainHeadingReducer from './modules/mainHeading/slice';
import setShowListReducer from './modules/showList/slice';
import dashboardReducer from './modules/dashboard/slice';
import enquiryReducer from './modules/home/slice';
import permissionsReducer from './modules/permissions/slice';

const rootReducer = combineReducers({
    auth: authReducer,
    branch: branchReducer,
    patientRegistration: patientRegistrationReducer,
    patientInformation: patientInformationReducer,
    patientEmergencyContact: patientEmergencyContactReducer,
    patientInsurance: patientInsuranceReducer,
    patientPhysician: patientPhysicianReducer,
    patientMedicalHistory: patientMedicalHistoryReducer,
    patientLifeStyle: patientLifeStyleReducer,
    patientAcknowledgement: patientAcknowledgementReducer,
    patientConsent: patientConsentReducer,
    patientProfile: patientProfileReducer,
    profile: profileReducer,
    staff: staffReducer,
    mainHeading: mainHeadingReducer,
    reduxShowList: setShowListReducer,
    dashboard: dashboardReducer,
    enquiry: enquiryReducer,
    permissions: permissionsReducer,
});

export default rootReducer;
